// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/images/bg-tablet-pattern.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/bg-simplify-section-desktop.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/bg-simplify-section-mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/carousel-1.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#homepage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 800px;
  background-position: 90% -25%;
}

#cta {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
}

@media (max-width: 576px) {
  #homepage {
    background-position: 50px -50px;
    background-size: 500px;
  }

  #cta {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
}

/* Hamburger Menu */

.hamburger {
  cursor: pointer;
  width: 24px;
  height: 24px;
  transition: all 0.25s;
  position: relative;
}

.hamburger-top,
.hamburger-middle,
.hamburger-bottom {
  position: absolute;
  top: 0;
  left: 0;
  width: 24px;
  height: 2px;
  background: #000;
  transform: rotate(0);
  transition: all 0.5s;
}

.hamburger-middle {
  transform: translateY(7px);
}

.hamburger-bottom {
  transform: translateY(14px);
}

.open {
  transform: rotate(90deg);
  transform: translateY(0px);
}

.open .hamburger-top {
  transform: rotate(45deg) translateY(6px) translate(6px);
}

.open .hamburger-middle {
  display: none;
}

.open .hamburger-bottom {
  transform: rotate(-45deg) translateY(6px) translate(-6px);
}

.page-header {
  background: linear-gradient(rgba(77, 66, 174, 0.5), rgba(62, 11, 171, 0.5)), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center no-repeat;
  background-size: cover;
}

.faqs {
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: 15px;
}

.faqs .faq {
  margin: 15px;
  padding: 15px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
}

.faqs .faq .faq-question {
  position: relative;
  font-size: 20px;
  padding-right: 80px;
  transition: all 0.4s ease;
}

.faqs .faq .faq-question::after {
  content: "+";
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  transition: all 0.2s ease;
}

.faqs .faq .faq-answer {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: all 0.2s ease;
}

.faqs .faq.open .faq-question {
  margin-bottom: 15px;
}

.faqs .faq.open .faq-question::after {
  content: "-";
}

.faqs .faq.open .faq-answer {
  max-height: 1000px;
  opacity: 1;
}

.FAQ {
  background: #eee;
}

/* override the carousel container flex start */

.rgr-carousel-container {
  justify-content: flex-start !important;
}`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AACA;EACE,yDAAmE;EACnE,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yDAAwE;EACxE,4BAA4B;AAC9B;;AAEA;EACE;IACE,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,yDAAuE;EACzE;AACF;;AAEA,mBAAmB;;AACnB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAyD;AAC3D;;AACA;EACE,4IAAwI;EACxI,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AACA;EACE,gBAAgB;AAClB;;AAGA,+CAA+C;;AAC/C;EACI,sCAAsC;AAC1C","sourcesContent":["\n#homepage {\n  background-image: url('../src/assets/images/bg-tablet-pattern.svg');\n  background-repeat: no-repeat;\n  background-size: 800px;\n  background-position: 90% -25%;\n}\n\n#cta {\n  background-image: url('./assets/images/bg-simplify-section-desktop.svg');\n  background-repeat: no-repeat;\n}\n\n@media (max-width: 576px) {\n  #homepage {\n    background-position: 50px -50px;\n    background-size: 500px;\n  }\n\n  #cta {\n    background-image: url('./assets/images/bg-simplify-section-mobile.svg');\n  }\n}\n\n/* Hamburger Menu */\n.hamburger {\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  transition: all 0.25s;\n  position: relative;\n}\n\n.hamburger-top,\n.hamburger-middle,\n.hamburger-bottom {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 24px;\n  height: 2px;\n  background: #000;\n  transform: rotate(0);\n  transition: all 0.5s;\n}\n\n.hamburger-middle {\n  transform: translateY(7px);\n}\n\n.hamburger-bottom {\n  transform: translateY(14px);\n}\n\n.open {\n  transform: rotate(90deg);\n  transform: translateY(0px);\n}\n\n.open .hamburger-top {\n  transform: rotate(45deg) translateY(6px) translate(6px);\n}\n\n.open .hamburger-middle {\n  display: none;\n}\n\n.open .hamburger-bottom {\n  transform: rotate(-45deg) translateY(6px) translate(-6px);\n}\n.page-header {\n  background: linear-gradient(rgba(77, 66, 174, 0.5), rgba(62, 11, 171, 0.5)), url(./assets/images/carousel-1.jpg) center center no-repeat;\n  background-size: cover;\n}\n\n.faqs {\n  width: 100%;\n  max-width: 768px;\n  margin: 0 auto;\n  padding: 15px;\n}\n\n.faqs .faq {\n  margin: 15px;\n  padding: 15px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n}\n\n.faqs .faq .faq-question {\n  position: relative;\n  font-size: 20px;\n  padding-right: 80px;\n  transition: all 0.4s ease;\n}\n\n.faqs .faq .faq-question::after {\n  content: \"+\";\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  transform: translateY(-50%);\n  width: 30px;\n  height: 30px;\n  transition: all 0.2s ease;\n}\n\n.faqs .faq .faq-answer {\n  opacity: 0;\n  max-height: 0;\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\n.faqs .faq.open .faq-question {\n  margin-bottom: 15px;\n}\n\n.faqs .faq.open .faq-question::after {\n  content: \"-\";\n}\n\n.faqs .faq.open .faq-answer {\n  max-height: 1000px;\n  opacity: 1;\n}\n.FAQ {\n  background: #eee;\n}\n\n\n/* override the carousel container flex start */\n.rgr-carousel-container {\n    justify-content: flex-start !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
